import { Component, Input} from '@angular/core';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'spinner-window',
    templateUrl: './spinner-window.component.html',
    imports: [
      ProgressSpinnerModule,
      AfTranslateDirective
    ]
})
export class SpinnerWindowComponent{
  constructor(public loader: LoaderFactory) {}
  @Input() text: string = '';
}
